/**
 *  Alaska
 *  Public: Marketing
 *
 *  @version 1.0
 */

document.addEventListener("alpine:init", () => {

    Alpine.data("Marketing", () => ({
        email: "",
        loading: false,

        async subscribe() {

            if (!this.email.trim()) {
                if (typeof Notification !== 'undefined') {
                    Notification.render("Please enter an email address.", "error");
                }
                return;
            }

            this.loading = true;

            try {
                const response = await fetch("/alaska/async/", {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({
                        controller: "Marketing",
                        action: "subscribe",
                        email: this.email
                    })
                });

                const result = await response.json();

                if (result.type === "success") {
                    // Success: Clear input and show message
                    if (typeof Notification !== 'undefined') {
                        Notification.render(result.message, "success");
                    }
                } else {
                    console.error("Subscribe failed:", result.message);
                    if (typeof Notification !== 'undefined') {
                        Notification.render(result.message || "An error occurred", "error");
                    }
                }
            } catch (error) {
                console.error("Request error:", error);
                if (typeof Notification !== 'undefined') {
                    Notification.render("Network error. Please try again.", "error");
                }
            } finally {
                this.email = "";
                this.loading = false;
            }
        }
    }));

});